export default __webpack_public_path__ + "static/media/grupo_venta.9a7396f6.svg";